import React from "react"

const OrderDetailItemList = ({ renderItems }) => {
  return (
    <div className="shopcart-detail">
      <div className="shopcart-columns-block">
        <div className="column-name image" />
        <div className="column-name">品名</div>
        <div className="column-name">價格</div>
        <div className="column-name">數量</div>
        <div className="column-name">小計</div>
        <div className="column-name">刪除</div>
      </div>

      <div className="shopcart-products-block">{renderItems()}</div>
    </div>
  )
}

export default OrderDetailItemList
